<template>
    <div class="similar-profiles-fake-list" data-testid="similar-profiles-fake-list">
        <SimilarProfilesList
            class="similar-profiles-fake-list__hidden_content"
            :similar-profiles="similarProfiles"
            :horizontally-scrollable="false"
        />
        <div class="similar-profiles-fake-list__overlay-content">
            <VJoyButton data-testid="similar-profiles-signup-cta" :href="signupUrl" rel="nofollow">
                {{ $t('profile.section.similar.signup.cta') }}
            </VJoyButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useRoute} from '@typed-router';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import type {SimilarProfile} from '~/openapi';
    import SimilarProfilesList from './SimilarProfilesList.vue';

    const route = useRoute();
    const signupUrl = computed(() => {
        const currentPageUrl = `/profile${route.fullPath}#${anchorsPageProfile.similarProfilesSection}`;
        return `/who-are-you?redirect=${encodeURIComponent(currentPageUrl)}&pageSource=profile_page&componentSource=profile-similar-profiles-section`;
    });

    const similarProfiles = [
        generateProfile(
            'Agata_FRYDRYCH_1',
            'Agatha',
            'Frydrych',
            'Backend Java Software Engineer',
            'https://dam.malt.com/profile/ProfilePictureSample003?w=80',
            4.7,
            3,
            2,
        ),
        generateProfile(
            'baptiste_duhen_1',
            'Baptiste',
            'Duhen',
            'Fullstack developer',
            'https://dam.malt.com/profile/ProfilePictureSample001?w=80',
            4.6,
            4,
            5,
        ),
        generateProfile(
            'Admin_Amed_Atchamou_1',
            'Amed',
            'Hamou',
            'Senior Lead Developer',
            'https://dam.malt.com/profile/ProfilePictureSample002?w=80',
            4,
            2,
            7,
        ),
        generateProfile('Admin_Cecile_Pelletier_2', 'Audrey', 'Champion', 'Web developer', 'https://dam.malt.com/profile/portrait3?w=80', 4.3, 3, 4),
    ];

    function generateProfile(
        profileId: string,
        firstname: string,
        lastname: string,
        headline: string,
        avatarUrl: string,
        averageRating: number,
        numberOfReviews: number,
        numberOfRecos: number,
    ): SimilarProfile {
        return {
            profileId,
            firstname,
            lastname,
            headline,
            canonicalUrl: '/profile',
            avatarUrl,
            reviews: {
                averageRating: averageRating,
                numberOfRatings: numberOfReviews,
            },
            numberOfRecommendations: numberOfRecos,
        };
    }
</script>
<style lang="scss">
    .similar-profiles-fake-list {
        &__hidden_content {
            position: relative;
        }

        &__overlay-content {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: hsla(0, 0%, 100%, 0.9);
            backdrop-filter: blur(3px);
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
